import store from 'src/js/store';
import selectors from '../selectors';
import { SELECT } from '../constants/trigger-types';

function findAllFor(element, triggerType = SELECT) {
  const state = store.getState();
  const registeredTools = selectors.getTools(state);
  const filteredTools = registeredTools.filter((tool) => {
    const triggers = tool.triggerOn;
    // Support array triggerOn (e.g. [HOVER, SELECT]) so a single tool can activate
    // on multiple trigger types (needed for column-resize which works on both)
    return Array.isArray(triggers) ? triggers.includes(triggerType) : triggers === triggerType;
  });

  return filteredTools.filter((tool) => tool.matches(element));
}

export default findAllFor;
